import * as Tooltip from '@radix-ui/react-tooltip';

const timeAgo = (ms: number) => {
  const d = Date.now() - ms;
  const mins = Math.round(d / 60000);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.round(hrs / 24);
  return `${days}d ago`;
};

export function CreatedCell({ ms }: { ms?: number }) {
  if (!ms) return <span className="text-slate-400">—</span>;
  
  const full = new Date(ms).toLocaleString();
  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <time className="cursor-help">{timeAgo(ms)}</time>
        </Tooltip.Trigger>
        <Tooltip.Content 
          side="top"
          className="px-2 py-1 rounded bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 shadow border border-slate-200 dark:border-slate-700 text-xs"
        >
          {full}
          <Tooltip.Arrow className="fill-white dark:fill-slate-800" />
        </Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
